import styled from 'styled-components';

export const Container = styled.div<{ $fullPage?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ $fullPage, theme }) => $fullPage && `
    min-height: 100vh;
    background-color: ${theme.colors.pageBackground};
  `}
  ${({ $fullPage, theme }) => !$fullPage && `
    padding: ${theme.spacing.xl} ${theme.spacing.md};
  `}
`;

export const Spinner = styled.div<{ $size?: 'small' | 'medium' | 'large' }>`
  ${({ $size = 'medium', theme }) => {
    const sizes = {
      small: '24px',
      medium: '40px',
      large: '56px',
    };
    const borderWidth = {
      small: '2px',
      medium: '3px',
      large: '4px',
    };
    return `
      width: ${sizes[$size]};
      height: ${sizes[$size]};
      border: ${borderWidth[$size]} solid ${theme.colors.border.light};
    `;
  }}
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius.round};
  animation: spin 1s linear infinite;
  margin-bottom: ${({ theme }) => theme.spacing.md};

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const Message = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
`;
